module.exports = __webpack_public_path__ + "static/logo-black.719c6643_300x-e9ddb47b1f0e156740c2d7025b5a2638.png";